import { apiClient } from './client'

export interface Operador {
  id: string
  tenantId: string
  nombre: string
  documentoCi: string | null
  telefono: string | null
  activo: boolean
  creadoAt: string
}

export interface OperadorInput {
  nombre: string
  documentoCi?: string
  telefono?: string
  pinAcceso: string
}

export const operadoresApi = {
  list: () =>
    apiClient.get<{ items: Operador[] }>('/operadores').then((r) => r.data),

  getById: (id: string) =>
    apiClient.get<Operador>(`/operadores/${id}`).then((r) => r.data),

  create: (data: OperadorInput) =>
    apiClient.post<Operador>('/operadores', data).then((r) => r.data),

  update: (id: string, data: Partial<Omit<OperadorInput, 'pinAcceso'>>) =>
    apiClient.patch<Operador>(`/operadores/${id}`, data).then((r) => r.data),

  toggleActivo: (id: string, activo: boolean) =>
    apiClient.patch<Operador>(`/operadores/${id}`, { activo }).then((r) => r.data),
}
